import { TooltipRenderProps } from 'react-joyride';

const CustomWalkthroughTooltip = (props: TooltipRenderProps) => {
  const {
    continuous,
    index,
    primaryProps,
    skipProps,
    step,
    tooltipProps,
    size
  } = props;

  return (
    <div
      className='flex flex-col justify-between items-start gap-3 w-60 p-3 bg-white rounded-lg border border-gray-300'
      {...tooltipProps}
    >
      <div className='text-black font-iconiqQuadraat text-base font-light'>
        {step.content}
      </div>

      <div className='flex justify-between items-center w-full'>
        <p className='text-base font-light text-black opacity-50'>
          {index + 1}/{size}
        </p>
        <div className='flex items-center justify-start gap-5'>
          <button className='text-black outline-0 opacity-50' {...skipProps}>
            {skipProps.title}
          </button>

          {continuous && (
            <button className='text-black outline-0' {...primaryProps}>
              {primaryProps.title}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomWalkthroughTooltip;
